

































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import FileService from "@/services/FileService";

@Component
export default class Files extends Vue {
  @Prop() public query!: string;
  @Prop() public tags!: string;
  @Prop() public spinner!: boolean;
  public skip: number = -1;
  public loading = false;

  private fs = new FileService();
  private fileList: any = [];
  private total = 0;
  private endOfStream = false;

  private isStarred(file: any, userId: number) {
    try {
      return file.starred !== undefined && file.starred.includes(userId);
    } catch {
      return false;
    }
  }

  private mounted() {
    this.getFiles(true);
  }

  private getFiles(next = true, isStarred = false) {
    isStarred = this.$route.path === "/documents/starred";
    if (this.endOfStream) {
      return;
    }

    const query = this.query;
    const tags = this.tags;

    this.loading = true;

    if (next) {
      this.skip += 1;
    } else {
      this.skip -= 1;
    }

    if (this.skip < 0) {
      this.skip = 0;
    }

    if (tags !== undefined || query !== undefined) {
      if (tags !== undefined) {
        (this as any).$globalService.setQuery(tags);
        (this as any).$globalService.setMode(true);
      } else if (query !== undefined) {
        (this as any).$globalService.setQuery(query);
        (this as any).$globalService.setMode(false);
      }
      this.fs
        .searchFiles(tags as string, query as string, this.skip)
        .then((response) => {
          // this.fileList = response.files;
          const files = response.files;
          for (const f of files) {
            if (f.starred === null) {
              f.starred = [];
            }
          }

          this.fileList = this.fileList.concat(files);
          const uid = (this as any).$userService.user.id;
          this.total = response.total;

          // window.scrollTo(0, 0);
          this.loading = false;

          this.endOfStream =
            this.fileList.length !== 30 * (this.skip + 1) || this.skip >= 500;
        });
    } else {
      (this as any).$globalService.setQuery("");
      (this as any).$globalService.setMode(false);
      this.fs.getFiles(this.skip, isStarred).then((response) => {
        // this.fileList = response.files;
        this.fileList = this.fileList.concat(response.files);
        this.total = response.total;

        const uid = (this as any).$userService.user.id;

        // window.scrollTo(0, 0);
        this.loading = false;
        this.endOfStream =
          this.fileList.length !== 30 * (this.skip + 1) || this.skip >= 500;
      });
    }
  }

  private getFile(key: string) {
    this.fs.getFile(key).then((response) => {
      // window.open(response.data.url, "_blank");
      document.location.href = response.data.url;
    });
  }

  private starFile(file: any, user = 1) {
    this.fs.starFile(file.uuid).then((response) => {
      if ((response as any).data.status === 1) {
        file.starred.push(user);
      } else {
        file.starred.pop(user);
      }
    });
  }

  private goToTag(tag: string) {
    this.$router.push("/search?query=tag:" + tag);
  }

  private goToFile(uuid: string) {
    this.$router.push("/document/" + uuid);
  }
}
